import { Injectable } from "@angular/core";

/**
 * Serviço responsável por gerar indetificador alfabético.
 */
@Injectable({
    providedIn: "root"
})
export class GenerateAlphabeticIdentifierService {

    private readonly UTF_16_A_POSITION = 65;
    private readonly UTF_16_Z_POSITION = 90;

    /**
     * Gera um identificador alfabético concatenando a letra do alfabeto com o prefixo informado.
     * Ex.: Link A, Link B.
     *
     * Para gerar esse identificador utilizamos a tabela UTF-16 (https://asecuritysite.com/coding/asc2),
     * onde:
     * - 65 representa o caracter 'A'
     * - 90 representa o caracter 'Z'
     *
     * @param prefix - Prefixo do identificador
     * @param identifiersInUse - identificadores em uso (com prefixo).
     * @returns - Próximo identificador disponível
     */
    generate(prefix: string, identifiersInUse: Array<string>): string {
        let identifier = "";

        for (let index = this.UTF_16_A_POSITION; index <= this.UTF_16_Z_POSITION; index++) {
            const tempIdentifier = `${prefix} ${String.fromCharCode(index)}`;

            if (!identifiersInUse.includes(tempIdentifier)) {
                identifiersInUse.push(tempIdentifier);
                identifier = tempIdentifier;
                break;
            }
        }

        return identifier;
    }
}
